export default defineNuxtRouteMiddleware((to, from) => {
   const { getAuthed, user } = useAuthStore();

   if (to.name === "login-modal" && getAuthed) {
      return navigateTo(`/home/${user?.school.slug}`);
   }
});
